import { ApiBugtrackerRequest, BugtrackerRequest } from './shared'
import { UseFormGetValues } from 'react-hook-form/dist/types/form'
import { JiraFormFieldTypes } from '../../jira/jira-integration-page/jira-form-field-types'

export const buildApiPayloadBugtrackerCredentials = (
  bugtracker: BugtrackerRequest | null
): ApiBugtrackerRequest | null => {
  if (!bugtracker) {
    return null
  } else if (
    // if newer credentials are available use those
    bugtracker.credentials &&
    bugtracker.credentials.host &&
    bugtracker.credentials.username &&
    bugtracker.credentials.password
  ) {
    return {
      credentials: bugtracker.credentials,
      name: bugtracker.name
    }
  } else if (bugtracker.credentials_id) {
    return {
      name: bugtracker.name,
      credentials_id: bugtracker.credentials_id
    }
  } else {
    return null
  }
}

export const transformFormDataToBugtrackerRequest = (
  getValues: UseFormGetValues<any>
): BugtrackerRequest => {
  return {
    name: getValues('name') ?? 'Default Test Connection',
    credentials_id: getValues(JiraFormFieldTypes.CREDENTIALS_ID),
    credentials: {
      name: getValues(JiraFormFieldTypes.CREDENTIALS_NAME),
      username: getValues(JiraFormFieldTypes.CREDENTIALS_USERNAME),
      password: getValues(JiraFormFieldTypes.CREDENTIALS_PASSWORD),
      host: getValues(JiraFormFieldTypes.CREDENTIALS_HOST)
    }
  }
}
